module.exports = __webpack_public_path__ + "artist.svg?024fc7f481c38c42ececb1ca7b613d1b";